export const SHOW = '@sweetalert/SHOW';
export const TRANSFORM = '@sweetalert/TRANSFORM';
export const CHANGE = '@sweetalert/CHANGE';
export const CLOSE = '@sweetalert/CLOSE';
export const LOADING = '@sweetalert/LOADING';
export const KEY = 'sweetAlert';
